const topics = [
  { name: '韩漫恋爱', hot: true, count: '2.3万' },
  { name: '日漫热血', hot: true, count: '1.8万' },
  { name: '国漫修仙', hot: true, count: '1.5万' },
  { name: '悬疑推理', hot: false, count: '8,620' },
  { name: '奇幻冒险', hot: false, count: '7,450' },
  { name: '校园青春', hot: false, count: '6,890' },
  { name: '霸道总裁', hot: true, count: '1.2万' },
  { name: '古风武侠', hot: false, count: '5,340' },
  { name: '末日生存', hot: false, count: '4,980' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            当下最受读者关注的漫画类型与话题标签，发现大家都在看什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#"
              className="group inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              {topic.hot && (
                <span className="flex items-center">
                  <i className="ri-fire-fill text-accent-500 text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.count} 作品</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}